import { motion } from "framer-motion";
import { X, Check } from "lucide-react";
import { Reveal, SectionLabel } from "../../lib/motion";

const TYPICAL = [
  "Limited or no documentation",
  "Unverified buildability claims",
  "No county correspondence provided",
  "Buyer left to gather records alone",
];

const THIS_LISTING = [
  "Comprehensive due diligence package",
  "County & HOA correspondence included",
  "Historical environmental records provided",
  "Organized to support informed decisions",
];

export const WhyDifferent = () => {
  return (
    <section className="py-24 md:py-32 bg-white">
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        <Reveal className="max-w-3xl">
          <SectionLabel>The Difference</SectionLabel>
          <h2 className="font-serif text-4xl md:text-5xl font-light text-navy mt-4 leading-tight">
            Why This Listing Is Different
          </h2>
          <p className="mt-5 text-warm leading-relaxed text-lg">
            Most vacant land listings provide only limited information. This property is offered with
            a comprehensive due diligence package — including county correspondence, property records,
            HOA information, historical environmental records, and supporting documentation — so
            prospective buyers can make informed decisions with confidence.
          </p>
        </Reveal>

        <div className="mt-14 grid md:grid-cols-2 gap-6">
          <Reveal>
            <div className="h-full bg-warm-light/60 border border-warm-border rounded-3xl p-8">
              <div className="label-caps text-[11px] text-warm">Typical Land Listing</div>
              <div className="mt-6 space-y-4">
                {TYPICAL.map((t) => (
                  <div key={t} className="flex items-center gap-3 text-warm">
                    <div className="w-7 h-7 rounded-full bg-warm/10 flex items-center justify-center shrink-0">
                      <X size={15} className="text-warm" />
                    </div>
                    <span>{t}</span>
                  </div>
                ))}
              </div>
            </div>
          </Reveal>

          <Reveal delay={0.1}>
            <div className="h-full bg-navy text-white rounded-3xl p-8 shadow-[0_24px_70px_-24px_rgba(11,37,69,0.5)]">
              <div className="label-caps text-[11px] text-water">Bay Quarter Shores · Lot 17-L</div>
              <div className="mt-6 space-y-4">
                {THIS_LISTING.map((t, i) => (
                  <motion.div
                    key={t}
                    initial={{ opacity: 0, x: 12 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: i * 0.08 }}
                    className="flex items-center gap-3"
                  >
                    <div className="w-7 h-7 rounded-full bg-water flex items-center justify-center shrink-0">
                      <Check size={15} className="text-white" />
                    </div>
                    <span className="text-white/95">{t}</span>
                  </motion.div>
                ))}
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
